import React from 'react'
import { Field, Label } from '../../../atoms'
import AddressInput, { getAddressErrors } from '../../address-input'
import { addressbaseLookup } from '../../address-lookup/fetch'
import { get } from 'lodash-es'

const HomeAddress = ({
  register,
  errors,
  setValue,
  setError,
  clearErrors,
  addressFieldName,
  defaultAddress = undefined,
}) => {
  return (
    <Field>
      <Label>Home Address</Label>
      <div className='SMEform__input'>
        <AddressInput
          name={addressFieldName}
          onChange={(address) => {
            if (address && typeof address === 'object') {
              register(addressFieldName)
              setValue(addressFieldName, address)
              const newErrors = getAddressErrors(address)
              for (const [field, error] of Object.entries(newErrors)) {
                if (error) {
                  setError(`${addressFieldName}.${field}`, {
                    type: 'manual',
                    message: error,
                  })
                }
              }
              const oldDirectorDetailsAddressErrors = get(errors, addressFieldName)
              if (!oldDirectorDetailsAddressErrors) {
                return
              }
              for (const [field] of Object.entries(oldDirectorDetailsAddressErrors)) {
                if (!newErrors[field]) {
                  clearErrors(`${addressFieldName}.${field}`)
                }
              }
            }
          }}
          register={register}
          lookup={addressbaseLookup}
          errors={get(errors, addressFieldName)}
          formVariant='default'
          defaultAddressView={defaultAddress ? 'static' : 'postcode'}
          homeAddress={true}
          defaultFormValues={defaultAddress}
        />
      </div>
    </Field>
  )
}

export default HomeAddress
